import { Row, Col, Form } from "react-bootstrap";
import React, { useRef, useEffect, useState } from "react";
import { useAuth } from "provider/AuthContext";
import { useNavigate } from "react-router-dom";
import { useToast } from "provider/ToastProvider";
import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";

const StepForm2 = () => {
  const { mobileVerify, mobileVerifyErrors, mobileVerifyDispatch } = useMobileVerifyContext();
  const { logout, updateUser, userProfile } = useAuth();
  const navigate = useNavigate();
  const { showSuccessToast, showErrorToastSimple } = useToast();
  //for Resend OTP
  const [loading, setLoading] = useState(false);


  const otpLength = 6;
  const otp = mobileVerify?.otp || Array(otpLength).fill("");
  const otpRefs = useRef(Array.from({ length: otpLength }, () => React.createRef()));

  const updateOtp = (newOtp) => {
    mobileVerifyDispatch({
      type: "UPDATE_MOBILE_VERIFY",
      payload: { otp: newOtp },
    });
    mobileVerifyDispatch({
      type: "SET_ERRORS_MOBILE_VERIFY",
      payload: { otp: "" },
    });
  };

  useEffect(() => {
    if (otpRefs.current[0]?.current) {
      otpRefs.current[0].current.focus();
    }
  }, []);

  /*----------------For Resend OTP ---------------Start-----------*/
  const validateNo = () => {
    const errors = {};

    const mobile = mobileVerify?.mobile_no?.trim() || "";
    const mobileRegex = /^[6-9]\d{9}$/; // Indian 10-digit mobile starting with 6-9

    if (!mobile) {
      errors.mobile_no = "Mobile number is required";
    } else if (!mobileRegex.test(mobile)) {
      errors.mobile_no = "Please enter a valid 10-digit Indian mobile number";
    }

    mobileVerifyDispatch({
      type: "SET_ERRORS_MOBILE_VERIFY",
      payload: errors,
    });

    return Object.keys(errors).length === 0;
  };


  const resendOtp = async () => {
    if (!validateNo()) return;

    setLoading(true);
    try {
      // You can call your API or move to next step here
      const formData = new FormData();
      formData.append("mobile_no", mobileVerify?.mobile_no);
      const url = `mobile-no-verification`;
      // return
      const response = await apiCall({
        url: url,
        method: "POST",
        data: formData,
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const firstKey = Object.keys(apiData.errors)[0];
        return mobileVerifyDispatch({
          type: "SET_ERRORS_MOBILE_VERIFY",
          payload: apiData.errors[firstKey][0],
        });
      }
      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        mobileVerifyDispatch({
          type: "MOBILE_VERIFY_SET_STEP",
          payload: 2,
        });
      }
      if (apiData?.status === 0) {
        showErrorToastSimple(apiData?.message);
      }

    } catch (error) {
      console.error("Submission failed:", error);
      handleError(error, logout, navigate);
    } finally {
      setLoading(false);
    }
  };

  /*----------------For Resend OTP ---------------End-----------*/

  const verifyNo = async () => {
    setLoading(true);
    try {
      // You can call your API or move to next step here
      const formData = new FormData();
      formData.append("mobile_no", mobileVerify?.mobile_no);
      formData.append("otp", mobileVerify?.otp?.join("") || "");
      const url = `verify-mobile-no`;
      // return
      const response = await apiCall({
        url: url,
        method: "POST",
        data: formData,
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const firstKey = Object.keys(apiData.errors)[0];
        return mobileVerifyDispatch({
          type: "SET_ERRORS_MOBILE_VERIFY",
          payload: apiData.errors[firstKey][0],
        });
      }
      if (apiData?.status === 1) {
        const updateUserProfile = {
          ...userProfile,
          is_mobile_no_verified: true
        }
        updateUser(updateUserProfile)
        // showSuccessToast(apiData?.message);
        mobileVerifyDispatch({
          type: "MOBILE_VERIFY_SET_STEP",
          payload: 3,
        });
      }  
      if (apiData?.status === 0) {
        showErrorToastSimple(apiData?.message);
      }

    } catch (error) {
      console.error("Submission failed:", error);
      handleError(error, logout, navigate);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Row className="pt-5 mt-5">
      <Col xs={12} className="mb-3 text-center">
        <label className="font_colorfomr">
          Enter the OTP received on your number
        </label>
        <div className="my-4">
          <label className="Modal_label text-center">
            +91-{mobileVerify?.mobile_no || ''}{" "}
            <button type="button" className="changebtn ms-2" onClick={() => {
              mobileVerifyDispatch({
                type: "MOBILE_VERIFY_SET_STEP",
                payload: 1,
              });
            }}>
              Change No
            </button>
          </label>
        </div>
      </Col>

      <Col xs={12} className="mb-3 d-flex justify-content-center gap-2">
        {otp.map((digit, index) => (
          <div className="otp-container">
            <Form.Control
              key={index}
              type="text"
              maxLength={1}
              className={`text-center otp-input ${mobileVerifyErrors?.otp ? "is-invalid" : ""}`}
              style={{}}
              value={digit}
              ref={otpRefs.current[index]}
              onChange={(e) => {
                const val = e.target.value;
                if (/^[0-9]$/.test(val) || val === "") {
                  const newOtp = [...otp];
                  newOtp[index] = val;
                  updateOtp(newOtp);

                  // ✅ Add a safety check before accessing `current`
                  const nextRef = otpRefs.current[index + 1];
                  if (val !== "" && nextRef && nextRef.current) {
                    nextRef.current.focus();
                  }
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && otp[index] === "" && index > 0) {
                  const prevRef = otpRefs.current[index - 1];
                  if (prevRef && prevRef.current) {
                    prevRef.current.focus();
                  }
                }
              }}
            />
          </div>
        ))}
      </Col>

      {mobileVerifyErrors?.otp && (
        <Col xs={12} className="text-center mb-3">
          <div className="invalid-feedback d-block">{mobileVerifyErrors.otp}</div>
        </Col>
      )}

      <Col xs={12} className="text-center m-auto pb-4">
        <button
          className="changebtn d-block text-center m-auto"
          type="button"
          onClick={resendOtp}
          disabled={loading}
        >
          Resend otp
        </button>
      </Col>
      <Col lg={12} className="margin-remove pt-5">
        <div className="creat-safri d-flex justify-content-end">
          <button
            className="cancel_btn_safari"
            type="button"
            onClick={() => {
              mobileVerifyDispatch({
                type: "MOBILE_VERIFY_SET_STEP",
                payload: 1,
              });
            }}
            disabled={loading}
          >
            back
          </button>
          <button
            type="button"
            className="btn  font_set w-auto ms-2 next_screen"
            onClick={verifyNo}
            disabled={loading}
          >
            Verify
          </button>
        </div>
      </Col>
    </Row>
  );
};

export default StepForm2;
